var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonBillable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.31 5.69h.97c1.1 0 2 .9 2 2v9c0 1.1-.9 2-2 2H6.53m-2.84-.09a2.005 2.005 0 01-1.41-1.91v-9c0-1.1.9-2 2-2h11.68M22 3L3.5 21.5",
    stroke: "#63656E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.15 11.21H2.28v-2h10.95l-2.08 2z",
    fill: "#63656E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.01 15.81h2.37",
    stroke: "#63656E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.28 11.21h-8.49l2-2h6.49v2z",
    fill: "#63656E"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjMxIDUuNjg5OTRIMjAuMjhDMjEuMzggNS42ODk5NCAyMi4yOCA2LjU4OTk0IDIyLjI4IDcuNjg5OTRWMTYuNjg5OUMyMi4yOCAxNy43ODk5IDIxLjM4IDE4LjY4OTkgMjAuMjggMTguNjg5OUg2LjUzMDAzTTMuNjkwMDMgMTguNTk5OUMyLjg4MDAzIDE4LjM0OTkgMi4yODAwMyAxNy41ODk5IDIuMjgwMDMgMTYuNjg5OVY3LjY4OTk0QzIuMjgwMDMgNi41ODk5NCAzLjE4MDAzIDUuNjg5OTQgNC4yODAwMyA1LjY4OTk0SDE1Ljk2IiBzdHJva2U9IiM2MzY1NkUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjIgM0wzLjUgMjEuNSIgc3Ryb2tlPSIjNjM2NTZFIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTExLjE1IDExLjIxSDIuMjgwMDNWOS4yMDk5NkgxMy4yM0wxMS4xNSAxMS4yMVoiIGZpbGw9IiM2MzY1NkUiLz4KPHBhdGggZD0iTTE3LjAxIDE1LjgxMDFIMTkuMzgiIHN0cm9rZT0iIzYzNjU2RSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMi4yOCAxMS4yMUgxMy43OUwxNS43OSA5LjIwOTk2SDIyLjI4VjExLjIxWiIgZmlsbD0iIzYzNjU2RSIvPgo8L3N2Zz4K";
export { SvgNonBillable as ReactComponent };